const _views = new Map();
let _currentView = null;
let _stateData = {};

const ViewManager = {
  set_initial_state_data(data) {
    _stateData = data || {};
  },

  set_view(name) {
    // no-op — views auto-register via ApplicationView constructor
  },

  go_to_view(name, animate) {
    const view = _views.get(name);
    if (_currentView && _currentView !== view) {
      _currentView.on_exit(_stateData);
    }
    if (view) {
      _currentView = view;
      view.on_enter(_stateData);
    }
  },

  update() {
    if (_currentView && _currentView.update) {
      _currentView.update();
    }
  },

  _register(name, view) {
    _views.set(name, view);
  },
};

export { ViewManager };
